import React from 'react';
import styled, { css } from 'styled-components';

import { Link as _Link } from 'gatsby';
import { type Hyperlink } from '../settings/Hyperlinks';
import { getHostnameFromUrl } from '../utils/getHostnameFromUrl';

export const styles = css`
    --color: var(--foregroundColor);
    --hoverColor: var(--foregroundColor);
    --underlineColor: var(
        ${(props): string =>
            props.theme.backgroundLuminance >= 0.5
                ? '--foregroundColorMix6'
                : '--foregroundColorMix4'}
    );
    --hoverUnderlineColor: var(--highlightColor);

    color: var(--color);
    display: inline;
    cursor: pointer;
    text-decoration: underline;
    text-decoration-color: var(--underlineColor);
    text-underline-offset: var(--linkUnderlineOffset);
    text-decoration-thickness: var(--linkUnderlineThickness);

    &:hover,
    &:focus,
    &:active {
        color: var(--hoverColor);
        text-decoration-color: var(--hoverUnderlineColor);
        text-decoration-thickness: var(--linkUnderlineThicknessHover);
    }
`;

const Link = styled(_Link)`
    ${styles};
`;

export default Link;

export const A = styled.a`
    ${styles};
`;

export const HyperlinkA = ({
    hyperlink,
    linkText,
    hostNameAsLinkText,
    hostNameAsLinkTextStripWww = true,
    ...props
}: {
    hyperlink: Hyperlink;
    linkText?: string;
    hostNameAsLinkText?: boolean;
    hostNameAsLinkTextStripWww?: boolean;
} & React.HTMLAttributes<HTMLAnchorElement>): React.ReactElement => {
    return (
        <A {...props} href={hyperlink.url}>
            {hostNameAsLinkText
                ? getHostnameFromUrl(hyperlink.url, hostNameAsLinkTextStripWww)
                : linkText !== undefined
                  ? linkText
                  : hyperlink.title}
        </A>
    );
};

export const Button = styled.button`
    ${styles};
`;
